import React, {useState, Fragment, useEffect} from 'react'
import PropTypes from 'prop-types'
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import I18n from 'i18n-js';
import {Field} from 'formik';
import styled from 'styled-components';
import colors from '../../../../lib/Colors';
import {StyledErrorImage} from '../Form.styled';


const IntlInputWrapper = styled.div`

  ${props => (
  props.error && {
    borderBottomColor: `${colors.red} !important`
  } || {
    marginBottom: '1.5rem',
    borderBottomColor: `${colors.blue} !important`
  }
)}
   ${props => (
  props.customServerError && {
    borderBottomColor: `${colors.red} !important`,
    marginBottom: '1.5rem !important',
  } || {
    borderBottomColor: `${colors.blue}`
  }
)}
  & .intl-tel-input.allow-dropdown.separate-dial-code {
    width: 100%;
    & .selected-dial-code {
      margin-bottom: 0;
    }
    & .selected-flag {
      background-color: ${colors.white};
      transition: background-color 0.2s ease-in-out;
      border-right: 1px solid ${colors.lightestGray}; 
      &:hover {
        background-color: ${colors.almostWhite};
      }
    }
    & input {
      box-sizing: border-box;
      height: 42px;
      padding: 10px 10px 10px 80px;
      border: 1px solid transparent !important;
      width: 100% !important;
      border-radius: 3px 3px 0 0;
      color: ${colors.black} !important;
      &:focus {
        border-color: ${colors.blue};
        outline: none;
        color: ${colors.almostBlack};
      };
      ${({error}) => (error && {
  borderBottomColor: `${colors.red} !important`,
} || {
  borderBottomColor: `${colors.blue} !important`,
})}
       }
      };
 
`;

const MobilePhoneDisclaimer = styled.p`
  color: ${colors.mediumGray};
  height: 0;
  margin: 0;
  opacity: 0;
  transition: 
    margin 0.2s ease-in-out,
    height 0.2s ease-in-out,
    opacity 0.2s ease-in-out;
  ${({showDisclaimer}) => {
  return showDisclaimer ? 'margin-top: 5px; height: 40px; opacity: 1;' : ''
}};
`

const PhoneNumber = ({error, field: {name}, disclaimer, phoneError}) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [phoneCustomErrorState, setCustomPhoneError] = useState(false);

  useEffect(() => {
    setCustomPhoneError(phoneError);
  }, [phoneError]);

  const handlePhoneNumberChange = (setFieldError) => {
    setCustomPhoneError(false);
    setFieldError(name, null);
  };

  // underlying 3rd-party form lib does not correctly validate phone numbers:
  // intlTelInputUtils.isValidNumber('+16725143701', 'ca') = false
  // intlTelInputUtils.isValidNumber('+19452164679', 'us') = false
  const handlePhoneNumberBlur = (isValidRaw, value, countryData, fullNumber, setFieldValue, setFieldError, setFieldTouched) => {
    const phoneNumberFormat = /^\+?[\-\d()\s]*$/;   // may start with + and then contains (, ), -, space, numbers

    let isValid = isValidRaw;
    if (!isValid) {
      // override validation error if needed
      if (phoneNumberFormat.test(fullNumber)) {
        if (countryData.iso2.toLowerCase() === 'us') {
          // US number should be 11 digits
          const digits = fullNumber.match(/(\d+)/g).join('');
          isValid = digits.length === 11;
        } else {
          // international number
          isValid = true;
        }
      } else {
        isValid = false;
      }
    }

    if (!isValid) {
      setFieldTouched(name, true, false);
      setFieldError(name, I18n.t('errors.phoneNumberFieldError'));
    } else {
      setFieldValue(name, fullNumber, false);    // updates form state only if value is valid - current form setup cannot reinforce all necessary validation at submit time
      setFieldError(name, null);
      setFieldTouched(name, false, true);
    }
  };

  return (
    <Fragment>
      <Field name={name}>
        {({form: {setFieldValue, setFieldTouched, setFieldError}}) => (
          <IntlInputWrapper customServerError={phoneCustomErrorState} error={error || phoneCustomErrorState}>
            <IntlTelInput // https://github.com/patw0929/react-intl-tel-input/blob/master/src/components/IntlTelInput.js
              autoComplete={'none'}
              format={true}
              name={name}
              onPhoneNumberBlur={(isValid, value, countryData, fullNumber) => {
                handlePhoneNumberBlur(isValid, value, countryData, fullNumber, setFieldValue, setFieldError, setFieldTouched)
                if (disclaimer) {
                  setShowDisclaimer(false);
                }
              }}
              onPhoneNumberChange={() => {
                handlePhoneNumberChange(setFieldError)
              }}
              onPhoneNumberFocus={() => {
                if (disclaimer) {
                  setShowDisclaimer(true)
                }
              }}
              placeholder={I18n.t('auth.mobilePhonePlaceholder')}
              preferredCountries={['us', 'ua']} // selected for easier testing of form for now.
              separateDialCode
            />
            <MobilePhoneDisclaimer showDisclaimer={showDisclaimer}>
              {disclaimer}
            </MobilePhoneDisclaimer>
          </IntlInputWrapper>
        )}
      </Field>
      {phoneCustomErrorState && (
        <StyledErrorImage>
          <svg height='20' width='20'>
            <use xlinkHref="#error"/>
          </svg>
        </StyledErrorImage>
      )}
    </Fragment>
  );
};

PhoneNumber.propTypes = {
  disclaimer: PropTypes.string,
  error: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string
  }),
  phoneError: PropTypes.bool
};

PhoneNumber.defaultProps = {
  disclaimer: ''
};

export default PhoneNumber;

